import {useMemo} from "react"
import {CONSTANTS} from "../../constants/constants"
import type {IdleCropState} from "../../types/types"
import {useCropper} from "../useCropper"
import {useImageCrop} from "../useImageCrop"
import {useVideoProcessing} from "../useVideoProcessing"

export const useCropperLogic = (materialIndex: number) => {
    const cropper = useCropper(materialIndex)

    const defaultImageState = useMemo(
        () => ({
            status: "initial" as const,
            dimensions: {width: 0, height: 0},
            position: {x: 0, y: 0},
            zoom: 100,
            videoPlaying: false,
        }),
        []
    )

    const defaultCropState = useMemo(
        () =>
            ({
                status: "idle" as const,
                isDragging: false as const,
                dragStart: {x: 0, y: 0},
                dimensions: {
                    width: CONSTANTS.DEFAULT_CROP_WIDTH,
                    height: CONSTANTS.DEFAULT_CROP_HEIGHT,
                },
            } as IdleCropState),
        []
    )

    const imageCrop = useImageCrop({
        materialIndex,
    })

    const videoProcessing = useVideoProcessing({
        materialIndex,
    })

    const imageState = cropper?.imageState || defaultImageState
    const cropState = cropper?.cropState || defaultCropState
    const mode = cropper?.mode || CONSTANTS.EDITOR_MODES.CROP
    const cropParams = cropper?.cropParams || null
    const isProcessing = cropper?.isProcessing || false
    const downloadUrl = cropper?.downloadUrl || null
    const uploadProgress = cropper?.uploadProgress || 0

    return {
        imageState,
        cropState,
        mode,
        cropParams,
        isProcessing,
        downloadUrl,
        uploadProgress,

        handleImageUpload: imageCrop.handleImageUpload,
        handleZoomChange: imageCrop.handleZoomChange,
        handleDimensionChange: imageCrop.handleDimensionChange,
        handleModeSwitch: imageCrop.handleModeSwitch,
        handleDragStart: imageCrop.handleDragStart,
        handleDrag: imageCrop.handleDrag,
        handleDragEnd: imageCrop.handleDragEnd,
        handleMouseLeave: imageCrop.handleMouseLeave,
        processVideo: videoProcessing.processVideo,
        downloadProcessedVideo: videoProcessing.downloadProcessedVideo,

        mainCanvasRef: imageCrop.mainCanvasRef,

        minZoom: imageCrop.minZoom,
        maxZoom: imageCrop.maxZoom,
        step: imageCrop.step,
    }
}
